module.exports = __webpack_public_path__ + "static/media/book-texture3.54677084.png";